import { useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useFamilySuppliers(family, input = "", category = "") {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("ListarProveedoresFamilias.php", {
      token: userData.token,
      familia: family,
      inputFiltro: input,
      categoria: category,
    });
    setList(response);
  }

  useEffect(() => {
    getData();
  }, [JSON.stringify(family), input, category]);

  return list;
}
